import './filters.less';
import { selectors } from './../../';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import _isEmpty from 'lodash/fp/isEmpty';
import CategoryFilter from './category-filter';

import React from 'react';
import PropTypes from 'prop-types';

const optionMapping = {
	date: 'New first',
	price: 'Highest price',
	priceAsc: 'Lowest price',
	title: 'By name'
};

class Main extends React.Component {

	render() {
		const { categories, intl, user, toggleCategoryItem, onlyAvailable,
			toggleOrderItem, toggleOnlyAvailable, query } = this.props;
		return (
			<div className='goods-filters-container'>
				<CategoryFilter
					intl={intl}
					categories={categories}
					selected={query.filters.categories}
					toggleCategoryItem={toggleCategoryItem}
				/>
				<Order
					intl={intl}
					isMultiselect={false}
					options={['date', 'title', 'priceAsc', 'price']}
					selected={query.sort}
					toggleOrderItem={toggleOrderItem}
				/>{
					!_isEmpty(user) &&
					<AvailabilityFilter
						options={['All', 'Available to me']}
						toggleOnlyAvailable={toggleOnlyAvailable}
						isOnlyAvailable={onlyAvailable}
						intl={intl}
					/>

				}
			</div>
		);
	}
}

class Order extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOptionShow: false
		};
		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.hidePopup = this.hidePopup.bind(this);
		this.handleEscButtonPress = this.handleEscButtonPress.bind(this);
	}
	setWrapperRef(node) {
		this.wrapperRef = node;
	}
	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.hidePopup();
		}
	}
	hidePopup() {
		this.setState(() => ({isOptionShow: false}));
	}
	handleEscButtonPress(e) {
		e.key == 'Escape' && (this.hidePopup());
	}
	componentDidMount() {
		document.addEventListener('keydown', this.handleEscButtonPress);
		document.addEventListener('click', this.handleClickOutside);
	}
	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleEscButtonPress);
		document.removeEventListener('click', this.handleClickOutside);
	}
	render() {
		const {intl, options, selected, toggleOrderItem} = this.props;
		let order = selected[0];
		_get(this.props, 'selected[1]') === 'asc' && _get(this.props, 'selected[0]') === 'price' && (
			order = 'priceAsc'
		);

		return (
			<div
				style={{position: 'relative', margin: '0 10px'}}
				className='single-filter__container'
				ref={this.setWrapperRef}
			>
				<div
					className={`controls__slide-down ${this.state.isOptionShow ? 'active':''}`}
					onClick={() => {this.setState(state=>({isOptionShow: !state.isOptionShow}));}}
				>
					{(!selected.length || !selected[0]) ? intl('Without sort') : intl(optionMapping[order])}
					<span className={`arrow-dropdown ${this.state.isOptionShow && 'active'}`}></span>
				</div>
				{this.state.isOptionShow &&
				<div
					className='select-items-container'
					style={{position: 'absolute',
						top: '21px', paddingTop: '15px', width: '100%', zIndex: '1000'}}>
					{options.map((option, index) => (
						<div
							className={`filter-option ${[order].includes(option)?'active':''}`}
							key={index}
							onClick={() => {toggleOrderItem(
								option !== 'priceAsc' ? option : 'price',
								!['priceAsc', 'title'].includes(option) ? 'desc' : 'asc'
							);}}
						>
							<span>
								{intl(optionMapping[option])}
							</span>
						</div>
					))
					}
				</div>
				}

			</div>
		);
	}
}

Main.propTypes = {
	intl: PropTypes.func,
	toggleOnlyAvailable: PropTypes.func,
	toggleOrderItem: PropTypes.func,
	toggleCategoryItem: PropTypes.func,
	onlyAvailable: PropTypes.array,
	user: PropTypes.object,
	query: PropTypes.object
};

Order.propTypes = {
	intl: PropTypes.func,
	selected: PropTypes.array,
	toggleOrderItem: PropTypes.func,
	options: PropTypes.array
};

class AvailabilityFilter extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isOptionShow: false,
			selectedOption: 'All'
		};
		this.setWrapperRef = this.setWrapperRef.bind(this);
		this.handleClickOutside = this.handleClickOutside.bind(this);
		this.hidePopup = this.hidePopup.bind(this);
		this.handleEscButtonPress = this.handleEscButtonPress.bind(this);
	}
	setWrapperRef(node) {
		this.wrapperRef = node;
	}
	handleClickOutside(event) {
		if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
			this.hidePopup();
		}
	}
	hidePopup() {
		this.setState(() => ({isOptionShow: false}));
	}
	handleEscButtonPress(e) {
		e.key == 'Escape' && (this.hidePopup());
	}
	componentDidMount() {
		document.addEventListener('keydown', this.handleEscButtonPress);
		document.addEventListener('click', this.handleClickOutside);
	}
	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleEscButtonPress);
		document.removeEventListener('click', this.handleClickOutside);
	}
	render() {
		const {intl, options, toggleOnlyAvailable} = this.props;
		return (
			<div
				className='single-filter__container availability-filter'
				ref={this.setWrapperRef}
			>
				<div
					className={`controls__slide-down ${this.state.isOptionShow ? 'active':''}`}
					onClick={() => {this.setState(state=>({isOptionShow: !state.isOptionShow}));}}
				>
					{intl(this.state.selectedOption)}
					<span className={`arrow-dropdown ${this.state.isOptionShow && 'active'}`}></span>
				</div>
				{this.state.isOptionShow &&
				<div
					className='select-items-container'
				>
					{options.map((option, index) => (option!==this.state.selectedOption) &&(
						<div
							className={`filter-option ${this.state.selectedOption === option ?'active':''}`}
							key={index}
							onClick={() => {
								this.setState(state => ({...state, selectedOption: option}));
								toggleOnlyAvailable();
							}}
						>
							<span>
								{intl(option)}
							</span>
						</div>
					))
					}
				</div>
				}

			</div>
		);
	}
}

AvailabilityFilter.propTypes = {
	intl: PropTypes.func,
	selected: PropTypes.array,
	toggleOnlyAvailable: PropTypes.func,
	options: PropTypes.array
};
export default connect(state => ({
	onlyAvailable: selectors.getOnlyAvailable(state)
}))(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/modules/market/components/store/filters.js